export default __webpack_public_path__ + "static/media/87.5127f54a.png";